import React, { Component } from 'react';
import { connect } from 'react-redux';

import { normalizeCurrencyValue } from '../../../../utils/ddny';

import LoadingIcon from '../../../common/icons/LoadingIcon';

import styles from './_styles/AddVariant.module.scss';

import * as ddnyActionCreators from '../../../../actions/ddny';
const allActionCreators = Object.assign({}, ddnyActionCreators);

export class AddVariant extends Component {

	constructor(props) {
	
		super(props);
	
		this.state = {
			inputMetalColor: '',
			inputMetalColorAlt: '',
			inputMetalWeight: '',
			inputMetalWeightAlt: '',
			inputCost: '',
			inputPrice: '',

			errorMetalColor: '',
			errorMetalColorAlt: '',
			errorMetalWeight: '',
			errorMetalWeightAlt: '',
			errorCost: '',
			errorPrice: '',

			requestPending: false,
			requestError: '',
		};
	}

	metalColor() {
		return this.state.inputMetalColor !== 'Other' ? this.state.inputMetalColor : this.state.inputMetalColorAlt.trim();
	}

	metalWeight() {
		return this.state.inputMetalWeight !== 'Other' ? this.state.inputMetalWeight : this.state.inputMetalWeightAlt.trim();
	}

	variantAlreadyExists() {
		for(const vnt of this.props.product?.variants) {
			if(vnt.gold_color === this.metalColor() && vnt.gold_weight === this.metalWeight()) {
				return true;
			}
		}
		return false;
	}

	async handleSubmit(evt) {
		if(evt) { evt.preventDefault(); }

		if(this.variantAlreadyExists()) {
			this.setState({ requestError: 'An identical variant already exists' });
			return;
		}

		const v0 = this.validateColor();
		const v1 = this.validateColorAlt();
		const v2 = this.validateWeight();
		const v3 = this.validateWeightAlt();
		const v4 = this.validateCost();
		const v5 = this.validatePrice();

		if(v0 && v1 && v2 && v3 && v4 && v5) {
			
			this.setState({
				requestPending: true,
				requestError: '',
			});

			try {

				const variantData = {
					product_id: this.props.product.id,
					metal_color: this.metalColor(),
					metal_weight: this.metalWeight(),
				}

				if(parseFloat(this.state.inputCost)) {
					variantData['cost'] = parseFloat(this.state.inputCost);
				}

				if(parseFloat(this.state.inputPrice)) {
					variantData['price'] = parseFloat(this.state.inputPrice);
				}

				await this.props.ddnyCreateVariant(variantData);
				await this.props.refresh({ showLoading: false });

				this.props.setOpen(false);

			} catch(err) {
				this.setState({
					requestPending: false,
					requestError: err.msg || 'An unexpected error has occurred',
				})
			}
		}
	}

	changeColor(evt) {
		this.setState({ 
			inputMetalColor: evt.target.value,
			inputMetalColorAlt: '',
			errorMetalColorAlt: '', 
			requestError: '', 
		}, () => {
			
			if(this.state.errorMetalColor) {
				this.validateColor();
			}

			if(this.state.inputMetalColor === 'Platinum') {
				this.setState({
					inputMetalWeight: '',
					inputMetalWeightAlt: '',
				});
			}
		});
	}

	validateColor() {
		if(!this.state.inputMetalColor) {
			this.setState({ errorMetalColor: 'Please select a metal color' });
			return false;
		}
		this.setState({ errorMetalColor: '' });
		return true;
	}

	changeColorAlt(evt) {
		this.setState({ 
			inputMetalColorAlt: evt.target.value, 
			requestError: '', 
		}, () => {
			if(this.state.errorMetalColorAlt) {
				this.validateColorAlt();
			}
		});
	}

	validateColorAlt() {
		if(this.state.inputMetalColor === 'Other' && this.state.inputMetalColorAlt === '') {
			this.setState({ errorMetalColorAlt: 'Please enter a metal color' });
			return false;
		}
		this.setState({ errorMetalColorAlt: '' });
		return true;
	}

	changeWeight(evt) {
		this.setState({ 
			inputMetalWeight: evt.target.value,
			inputMetalWeightAlt: '',
			errorMetalWeightAlt: '',
			requestError: '', 
		}, () => {
			if(this.state.errorMetalWeight) {
				this.validateWeight();
			}
		});
	}

	validateWeight() {
		if(this.state.inputMetalColor !== 'Platinum' && !this.state.inputMetalWeight) {
			this.setState({ errorMetalWeight: 'Please select a metal weight' });
			return false;
		}
		this.setState({ errorMetalWeight: '' });
		return true;
	}

	changeWeightAlt(evt) {
		this.setState({ 
			inputMetalWeightAlt: evt.target.value, 
			requestError: '', 
		}, () => {
			if(this.state.errorMetalWeightAlt) {
				this.validateWeightAlt();
			}
		});
	}

	validateWeightAlt() {
		if(this.state.inputMetalWeight === 'Other' && this.state.inputMetalWeightAlt === '') {
			this.setState({ errorMetalWeightAlt: 'Please enter a metal weight' });
			return false;
		}
		this.setState({ errorMetalWeightAlt: '' });
		return true;
	}

	changeCost(evt) {
		this.setState({ 
			inputCost: evt.target.value, 
			requestError: '', 
		}, () => {
			if(this.state.errorCost) {
				this.validateCost(false);
			}
		});
	}

	validateCost(shouldNormalize = true) {
		if(this.state.inputCost !== '') {

			if(!parseFloat(this.state.inputCost)) {
				this.setState({ errorCost: 'Please enter a valid cost' });
				return false;
			} else if(shouldNormalize) {
				this.setState({ inputCost: normalizeCurrencyValue(this.state.inputCost) });
			}
		}
		this.setState({ errorCost: '' });
		return true;
	}

	changePrice(evt) {
		this.setState({ 
			inputPrice: evt.target.value, 
			requestError: '', 
		}, () => {
			if(this.state.errorPrice) {
				this.validatePrice(false);
			}
		});
	}

	validatePrice(shouldNormalize = true) {
		if(this.state.inputPrice !== '') {

			if(!parseFloat(this.state.inputPrice)) {
				this.setState({ errorPrice: 'Please enter a valid price' });
				return false;
			} else if(shouldNormalize) {
				this.setState({ inputPrice: normalizeCurrencyValue(this.state.inputPrice) });
			}
		}
		this.setState({ errorPrice: '' });
		return true;
	}
	
	render() {
		return <div className={`${styles.AddVariant}`}>
			<div className={styles.titleSection}>
				<div className={styles.title}>New Variant</div>
			</div>

			{this.state.requestError && (
				<div className={styles.errorSection}>{this.state.requestError}</div>
			)}

			<div className={styles.inputSection}>
				<div className={styles.inputBlock}>
					<div className={`${styles.label} EllipsisElement`}>Metal Color</div>
					<div className={styles.inputElement}>
						<select
							className={this.state.errorMetalColor ? styles.error : ''}
							value={this.state.inputMetalColor}
							onChange={this.changeColor.bind(this)}>
							<option value=''>Select metal color</option>
							<option value='Yellow Gold'>Yellow Gold</option>
							<option value='White Gold'>White Gold</option>
							<option value='Rose Gold'>Rose Gold</option>
							<option value='Platinum'>Platinum</option>
							<option value='Other'>Other</option>
						</select>
						{this.state.errorMetalColor && (
							<div className={styles.inputError}>{this.state.errorMetalColor}</div>
						)}
					</div>
					{this.state.inputMetalColor === 'Other' && (
						<div className={`${styles.inputElement} ${styles.secondaryInput}`}>
							<input
								className={this.state.errorMetalColorAlt ? styles.error : ''}
								value={this.state.inputMetalColorAlt}
								onChange={this.changeColorAlt.bind(this)}
								onBlur={this.validateColorAlt.bind(this)}
								placeholder='Metal color' />
							{this.state.errorMetalColorAlt && (
								<div className={styles.inputError}>{this.state.errorMetalColorAlt}</div>
							)}
						</div>
					)}
				</div>
				{this.state.inputMetalColor !== 'Platinum' && (
					<div className={styles.inputBlock}>
						<div className={`${styles.label} EllipsisElement`}>Metal Weight</div>
						<div className={styles.inputElement}>
							<select
								className={this.state.errorMetalWeight ? styles.error : ''}
								value={this.state.inputMetalWeight}
								onChange={this.changeWeight.bind(this)}>
								<option value=''>Select metal Weight</option>
								<option value='14k'>14k</option>
								<option value='18k'>18k</option>
								<option value='Other'>Other</option>
							</select>
							{this.state.errorMetalWeight && (
								<div className={styles.inputError}>{this.state.errorMetalWeight}</div>
							)}
						</div>
						{this.state.inputMetalWeight === 'Other' && (
							<div className={`${styles.inputElement} ${styles.secondaryInput}`}>
								<input
									className={this.state.errorMetalWeightAlt ? styles.error : ''}
									value={this.state.inputMetalWeightAlt}
									onChange={this.changeWeightAlt.bind(this)}
									onBlur={this.validateWeightAlt.bind(this)}
									placeholder='Metal weight' />
								{this.state.errorMetalWeightAlt && (
									<div className={styles.inputError}>{this.state.errorMetalWeightAlt}</div>
								)}
							</div>
						)}
					</div>
				)}
				<div className={styles.inputBlock}>
					<div className={`${styles.label} EllipsisElement`}>Store Cost</div>
					<div className={styles.inputElement}>
						<input
							type='number'
							min={0}
							step={0.01}
							className={this.state.errorCost ? styles.error : ''}
							value={this.state.inputCost}
							onChange={this.changeCost.bind(this)}
							onBlur={this.validateCost.bind(this)}
							placeholder='Optional' />
						{this.state.errorCost && (
							<div className={styles.inputError}>{this.state.errorCost}</div>
						)}
					</div>
				</div>
				<div className={styles.inputBlock}>
					<div className={`${styles.label} EllipsisElement`}>Retail Price</div>
					<div className={styles.inputElement}>
						<input
							type='number'
							min={0}
							step={0.01}
							className={this.state.errorPrice ? styles.error : ''}
							value={this.state.inputPrice}
							onChange={this.changePrice.bind(this)}
							onBlur={this.validatePrice.bind(this)}
							placeholder='Optional' />
						{this.state.errorPrice && (
							<div className={styles.inputError}>{this.state.errorPrice}</div>
						)}
					</div>
				</div>

				{this.state.requestPending && (
					<div className={styles.loadingOverlay}>
						<div className={styles.loadingIcon}>
							<LoadingIcon />
						</div>
					</div>
				)}

			</div>

			<div className={styles.actionSection}>
				<button 
					className={`${styles.action} secondaryButton`} 
					disabled={this.state.requestPending}
					onClick={() => this.props.setOpen(false)}>
					Cancel
				</button>
				<button 
					className={`${styles.action} actionButton`} 
					disabled={this.state.requestPending}
					onClick={this.handleSubmit.bind(this)}>
					Save
				</button>
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(AddVariant);